import styles from './MenuSeparator.scss';

export const MenuSeparator = () => (
  <li className={styles.separator} role="separator" />
);
